import React from 'react';
import { Box, Container } from '@mui/material';
import classNames from 'classnames';
import styles from './site-components/site.module.css';

const CreativeStudio = () => {
  return (
    <div>
      <Container maxWidth="xl" className={classNames(styles.container)}>
        <div className={classNames(styles.csHeaderGrad, styles.headerOffset)}>
          <div className={styles.centerBlock}>
            <h1 className={classNames(styles.header, styles.headerSmallerWidth)}>
              Build assets for a captivated audience.
            </h1>
            <div className={classNames(styles.description, styles.medium)}>
              Build creatives and templates for new in-stream inventory and VAST compliant tags.
            </div>
          </div>

          <div className={classNames(styles.csHeader)} />
        </div>

        <div className={classNames(styles.centerBlock, styles.mt12)}>
          <h2 className={styles.tagLineHeading}>Get creative.</h2>
          <Box className={classNames(styles.description, styles.medium)}>
            Design creatives and templates for Stream Composer and Reach Extension VAST-compliant tags.
          </Box>
        </div>

        <div className={classNames(styles.featureGrid, styles.mt4, styles.section)}>
          <div className={classNames(styles.featureBox, styles.csPip, styles.gridTwoCol, styles.relative)}>
            <div className={classNames(styles.csPipSpacer)} />
            <div className={styles.featureTitle}>Picture-in-Picture</div>
            <div>Effortlessly merge content and ads within a unified video stream.</div>
          </div>
        </div>

        <div className={classNames(styles.featureGrid, styles.mt4, styles.section)}>
          <div className={classNames(styles.featureBox, styles.csSqueeze, styles.gridTwoCol, styles.relative)}>
            <div className={classNames(styles.csSqueezeSpacer)} />
            <div className={styles.featureTitle}>Squeeze Back</div>
            <div>
              Reveal personalized L-Bar and Dynamic Border Framed canvases that can be customized, animated, and IAB
              trackable.
            </div>
          </div>
        </div>

        <div className={classNames(styles.featureGrid, styles.mt4, styles.section)}>
          <div className={classNames(styles.featureBox, styles.csOverlay, styles.gridTwoCol, styles.relative)}>
            <div className={classNames(styles.csOverlaySpacer)} />
            <div className={styles.featureTitle}>Overlay</div>
            <div>Design custom overlays for your most premium content and brand advertisers.</div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default CreativeStudio;
